import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import {HttpMethod} from '@/constants/httpMethod';
import {EReducersPath} from '@/dataSource/utils/ReducerPaths';

import {setWafHeaders} from '../headers';
import {reAuth} from '../reAuth';

import {apiBaseEditInfo} from './constants';
import {IResolveEmailRequest, IResolveEmailResponse} from './entities';

const baseQuery = async (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    timeout: 30 * 1000,
    prepareHeaders: async headers => {
      await setWafHeaders(baseUrl, headers);
      return headers;
    },
  });

const baseApiQueryWithReAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const baseUrl = apiBaseEditInfo.baseUrl;
  const result = await reAuth(args, api, extraOptions, baseUrl, baseQuery);
  return result;
};

export const editInfoApi = createApi({
  reducerPath: EReducersPath.EDIT_INFO_API,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  baseQuery: baseApiQueryWithReAuth,
  endpoints: build => ({
    resolveEmail: build.mutation<IResolveEmailResponse, IResolveEmailRequest>({
      query: body => ({
        url: apiBaseEditInfo.endpoints.resolveEmail,
        method: HttpMethod.POST,
        body,
      }),
    }),
  }),
});

export const {useResolveEmailMutation} = editInfoApi;
